export const caseStudies = [
  {
    id: 'stat-climate',
    client: 'STAT Climate Control',
    industry: 'HVAC',
    location: 'Calgary, AB',
    title: '99% Visibility Across the 403',
    problem: 'High competition in Calgary Commercial & Residential HVAC made it impossible to break into the top 3 Map Pack. They were spending heavily on ads with diminishing returns.',
    solution: 'We focused on "Market Dominance" keywords and entity-based SEO. We optimized their site for seasonal HVAC shifts and built high-authority local backlinks.',
    strategy: [
      'Hyper-local neighborhood landing pages for Calgary SE, SW, and NW.',
      'Google Business Profile aggressive review velocity strategy.',
      'Technical schema markup for "HVAC Business" entities.',
      'AEO optimization for voice searches like "emergency furnace repair Calgary".'
    ],
    result: '99% visibility across the Calgary region and 2,975+ keywords ranking in the top 10.',
    stats: [
      { label: 'Visibility', value: '99%' },
      { label: 'Keywords', value: '2,975+' },
      { label: 'Leads', value: '+310%' }
    ],
    tags: ['HVAC', 'Calgary', 'Dominance']
  },
  {
    id: 'ems-inc',
    client: 'EMS Inc',
    industry: 'Electrical',
    location: 'Calgary, AB',
    title: 'Dominating Emergency Calls 24/7',
    problem: 'Managing a 24/7 emergency electrical fleet while maintaining high customer service standards and capturing "immediate need" search traffic.',
    solution: 'Targeted "High-Intent" emergency keywords (e.g., "Emergency Electrician Calgary") and integrated AI Voice text-back for instant response.',
    strategy: [
      'Dynamic search ads for emergency-related timeframes.',
      'AI-driven missed-call text-back system.',
      'Map Pack dominance for "Electrician Near Me" queries.',
      'Optimized landing pages for specific emergency services (panel repair, outages).'
    ],
    result: 'The phone rings the moment things go dark. 24/7 lead capture with zero missed opportunities.',
    stats: [
      { label: 'Inbound Calls', value: '24/7' },
      { label: 'Response Time', value: '< 1m' },
      { label: 'ROI', value: '12.5x' }
    ],
    tags: ['Electrical', 'Emergency', 'Voice AI']
  },
  {
    id: 'mcnedra',
    client: 'Mcnedra Construction',
    industry: 'Construction',
    location: 'Alberta',
    title: 'Digital Foundation for Growth',
    problem: 'Struggling with low online visibility and an outdated web presence that did not reflect their high-end craftsmanship.',
    solution: 'Complete website redesign optimized for high-conversion and a hyper-local SEO campaign targeting high-ticket renovation projects.',
    strategy: [
      'Visual-first portfolio SEO with image optimization.',
      'Content strategy around "Custom Home Building Alberta".',
      'Lead qualification funnel to filter high-ticket clients.',
      'Performance-based technical SEO for under 1s load times.'
    ],
    result: 'Significant increase in organic visibility and a professional digital storefront that closes high-ticket contracts.',
    stats: [
      { label: 'Traffic', value: '+450%' },
      { label: 'Design Score', value: '100%' },
      { label: 'Conv. Rate', value: '8.2%' }
    ],
    tags: ['Construction', 'Web Design', 'Visibility']
  },
  {
    id: 'dgees',
    client: 'D Gees Management & Realty',
    industry: 'Real Estate',
    location: 'Alberta',
    title: 'Real Estate Authority Building',
    problem: 'High-volume real estate market saturation made it difficult for local management and realty services to stand out from national franchises.',
    solution: 'Authority content marketing and entity-based SEO to rank for property management and luxury realty-specific intent.',
    strategy: [
      'Authority whitepapers on Alberta property investment.',
      'Local realtor schema for individual agents.',
      'Neighborhood-specific real estate market guides.',
      'Automated tenant lead qualification system.'
    ],
    result: 'Established as a go-to authority in the region, driving consistent property owner and buyer leads.',
    stats: [
      { label: 'Owner Leads', value: 'Weekly' },
      { label: 'Auth. Score', value: 'High' },
      { label: 'Organic Fill', value: '65%' }
    ],
    tags: ['Real Estate', 'Management', 'Content']
  },
  {
    id: 'precision-craft',
    client: 'Precision Craft and Design',
    industry: 'Custom Cabinetry',
    location: 'Alberta',
    title: 'High-End Lead Generation',
    problem: 'Mass-market competition was drowning out their bespoke craftsmanship. They needed to reach luxury homeowners specifically.',
    solution: 'Luxury-focused SEO strategy combined with visual storytelling and "craftsmanship-intent" keyword targeting.',
    strategy: [
      'Targeting "Custom Kitchen Cabinets [City]" keywords.',
      'Visual SEO targeting Pinterest and Google Images.',
      'Expert-led content on woodworking and design trends.',
      'Direct-to-designer lead capture forms.'
    ],
    result: 'Dominance in high-ticket custom design searches, leading to a 6-month project backlog.',
    stats: [
      { label: 'Backlog', value: '6 Mo' },
      { label: 'Avg Sale', value: '+$40k' },
      { label: 'Lead Quality', value: 'Elite' }
    ],
    tags: ['Design', 'Luxury', 'SEO']
  },
  {
    id: 'geokat',
    client: 'Geokat Clean Pro',
    industry: 'Cleaning',
    location: 'Alberta',
    title: 'Cleaning Up Local Search',
    problem: 'Low lead volume from residential cleaning searches in a crowded marketplace with low barrier to entry.',
    solution: 'Localized "Near Me" optimization and review velocity strategy to dominate the Map Pack and build instant trust.',
    strategy: [
      'Aggressive GBP review campaign.',
      'Landing pages for "Move-In/Move-Out Cleaning".',
      'Local directory sync (Yelp, YellowPages, BBB).',
      'Instant booking integration.'
    ],
    result: 'Ranked #1 for primary cleaning keywords, leading to a 40% increase in monthly bookings.',
    stats: [
      { label: 'Bookings', value: '+40%' },
      { label: 'Map Rank', value: '#1' },
      { label: 'Reviews', value: '200+' }
    ],
    tags: ['Cleaning', 'Local SEO', 'Reviews']
  }
];